import { createFileRoute } from '@tanstack/react-router'
import { SystemViewPage } from 'pages/systemView/SystemView'
import { z } from 'zod'

const parseParams = z.object({
  entryID: z.string(),
})

function RouteComponent() {
  const { entryID } = Route.useParams()
  return <SystemViewPage entryID={entryID} />
}

export const Route = createFileRoute('/systemview/$entryID')({
  component: RouteComponent,
  params: {
    parse: (params) => parseParams.parse(params),
  },
  staticData: {
    title: 'System View',
    layout: {
      enableScrolling: false,
      enforceMaxWidth: false,
    },
  },
})
